module.exports = __webpack_public_path__ + "8180324ceb62267ab5043e69a754ba0f.png";